<template>
  <BaseContainer>
    <div
      class="flex flex-1"
    >
      <div class="flex w-full items-center justify-center">
        <div class="flex flex-col w-1/2 h-auto">
          <div class="flex flex-row justify-between items-center">
            <p class="text-white font-content text-xl w-3/4">
              {{ surveyVerdict.title }}
            </p>
            <div class="flex rounded-full bg-white w-16 h-16 items-center justify-center align-center">
              <span class="text-primary font-content-bold text-3xl">
                {{ surveyVerdict.score }}
              </span>
            </div>
          </div>
          <div
            v-if="surveyVerdict.description"
            class="flex flex-col bg-white p-5 my-5 rounded-lg"
          >
            <p class="font-content top-1">
              {{ surveyVerdict.description }}
            </p>
          </div>
          <CustomerCommunicationDialog
            v-if="data"
            :customer="data"
            :survey-id="surveyId"
            :slugs="['survey-verdict']"
            @certified="mutate"
          >
            <BaseButton density="comfortable" class="text-primary self-center">
              Envoyer un SMS
            </BaseButton>
          </CustomerCommunicationDialog>
          <div v-else-if="!data && isLoading" class="self-center">
            <Skeleton class="h-8 w-32" />
          </div>
        </div>
      </div>
    </div>
  </BaseContainer>
</template>

<script lang="ts" setup>
import BaseContainer from "@/core/components/base/BaseContainer.vue";
import {computed} from "vue";
import ConsumerKeyService from "@/consumer/services/ConsumerKeyService";
import useCustomer from "@/customer/composables/useCustomer";
import CustomerCommunicationDialog from "@/customer/components/customer-communication/CustomerCommunicationDialog.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Skeleton} from "@/core/components/ui/skeleton";

const props = defineProps<{
    surveyId: number;
    consumerKey: string;
    surveyVerdict: {
        title: string;
        score: number;
        description?: string;
    }
}>();

const customerId = computed(() => ConsumerKeyService.customerIdFromKey(props.consumerKey));
const {data, mutate, isLoading} = useCustomer(customerId.value ?? undefined);
</script>
